<template>
  <div>
    <label v-if="label" class="mb-0.5 block text-body-s-bold">{{ label }}</label>
    <DropDownSelect full-width>
      <template #activator="{ open }">
        <button
          data-testid="nested-multi-select-toggle"
          class="flex w-full items-center gap-1 rounded-sm border border-solid border-strong p-2 text-body-s text-subtle"
          @click.prevent="open"
        >
          <span class="grow text-left">{{ displayPlaceholder }}</span>
          <span v-if="props.modelValue?.length" class="rounded-sm bg-button-primary-success p-1 text-button-s text-inverse">
            {{ props.modelValue.length }}
          </span>
          <SvgIcon :path="mdiChevronDown" :size="24" class="text-main" />
        </button>
      </template>

      <ul data-testid="nested-multi-select-options" class="options-list m-0 list-none overflow-y-auto p-0">
        <li v-for="group in optionGroups" :key="`filter_${group.option.value}`" class="separate-rows">
          <CheckBox
            :model-value="props.modelValue?.includes(group.option.value)"
            class="w-full cursor-pointer p-3 whitespace-nowrap text-main hover:bg-surface-elevation-2"
            @update:model-value="handleCheckboxChange(group.option.value, $event)"
          >
            {{ group.option.text }}
          </CheckBox>

          <ul v-if="group.options.length" class="p-0">
            <li v-for="option in group.options" :key="`filter_${option.value}`">
              <CheckBox
                size="small"
                :model-value="props.modelValue?.includes(option.value)"
                class="w-full cursor-pointer p-3 pl-8 whitespace-nowrap text-main hover:bg-surface-elevation-2"
                @update:model-value="handleCheckboxChange(option.value, $event)"
              >
                {{ option.text }}
              </CheckBox>
            </li>
          </ul>
        </li>
      </ul>
    </DropDownSelect>
  </div>
</template>

<script setup lang="ts">
import { mdiChevronDown } from '@mdi/js'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

type Option = {
  text: string
  value: string
}

const props = defineProps<{
  modelValue?: string[]
  optionGroups: {
    option: Option
    options: Option[]
  }[]
  label: string
  placeholder?: string
}>()

const displayPlaceholder = computed(() => props.placeholder ?? t('VisitorProfiles.filterPanel.select'))

const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void
}>()

const handleCheckboxChange = (optionValue: string, checked: boolean) => {
  if (checked) {
    const newOptions = props.modelValue?.slice() || []
    newOptions.push(optionValue)

    emit('update:modelValue', newOptions)
  } else {
    const newOptions = (props.modelValue?.slice() || []).filter((option) => option !== optionValue)
    emit('update:modelValue', newOptions)
  }
}
</script>

<style scoped>
.options-list {
  max-height: 640px;
}
</style>
